/**
 * Merge static catalog dimensions with dynamic form-field dimensions.
 */
export function mergeDimensions(catalogDimensions = [], formFields = []) {
  const base = Array.isArray(catalogDimensions) ? catalogDimensions : [];
  const dynamic = (formFields || []).map((field) => ({
    id: field.id,
    label: field.label,
    key_type: field.key_type,
    is_numeric: field.is_numeric,
    form_ids: field.form_ids || [],
    forms: field.forms || [],
  }));

  const seen = new Set(base.map((item) => item.id));
  const merged = [...base];
  dynamic.forEach((item) => {
    if (item.id && !seen.has(item.id)) {
      merged.push(item);
      seen.add(item.id);
    }
  });
  return merged;
}

export default mergeDimensions;
